import React from "react";
import { getInventorySignClassName } from "../inventorySignStyles";

const InventorySignedRupeeAmount = ({ isAdd, amount }) => {
  const formattedAmount =
    typeof amount === "number" ? amount.toFixed(2) : amount;

  return (
    <span className={getInventorySignClassName(!!isAdd)}>
      {isAdd ? "+" : "-"} ₹ {formattedAmount}
    </span>
  );
};

export default InventorySignedRupeeAmount;
